import { render, staticRenderFns } from "./dynamicInfo.vue?vue&type=template&id=31ce007f&scoped=true"
import script from "./dynamicInfo.vue?vue&type=script&lang=js"
export * from "./dynamicInfo.vue?vue&type=script&lang=js"
import style0 from "./dynamicInfo.vue?vue&type=style&index=0&id=31ce007f&prod&rel=stylesheet%2Fless&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ce007f",
  null
  
)

export default component.exports